export const Loyalty = () => {
  return <></>;
};
